import { useContext } from "react";
import { SelectExperienceContext } from "./SelectExperienceContext";

const useSelectExperienceContext = () => useContext(SelectExperienceContext);

export default useSelectExperienceContext;
